import React from "react";

import MobileDialog from "@app/analytics/MeetingReport/components/MobileDialog";
import type { PersonTalkTimeInfo } from "@app/analytics/types";

import { Column, Row } from "@rui/Stack";

import { ParticipantRow } from "./styles";

const ParticipantsListDialog = ({
  data,
  numParticipants,
}: {
  data: PersonTalkTimeInfo[];
  numParticipants: number;
}) => {
  return (
    <MobileDialog id="participants" title={`Participants (${numParticipants})`}>
      <Column spacing={1}>
        {data.map((participant) => (
          <Row variant="apart" key={participant.name}>
            <ParticipantRow participant={participant} />
          </Row>
        ))}
      </Column>
    </MobileDialog>
  );
};

export default ParticipantsListDialog;
